<template>
  <div>
    <BaseModalHeader>
      <BaseHeading :semantic-level="2" :display-level="1">
        Nachricht an {{ alternativeContact.firstName }} {{ alternativeContact.lastName }}
      </BaseHeading>
    </BaseModalHeader>
    <BaseModalContent>
      <BaseText>Guten Tag,</BaseText>
      <BaseText>{{ contactInfo.firstName }} {{ contactInfo.lastName }} hat Sie als Kontaktperson für einen Servicetermin in {{ address }} angegeben. Die Auftragsnummer ist {{ workOrderId }}.</BaseText>
      <BaseText>Der Termin ist geplant am {{ timeslot.day }} von {{ timeslot.time }} Uhr.</BaseText>
      <BaseText>Geben Sie uns bitte im Terminierungsportal {{ childShortUrl }} eine Rückmeldung, ob Sie den Termin wahrnehmen können.</BaseText><br>
      <BaseLink url="https://www.istaexpress.de/datenschutz.html">
        Unsere Datenschutzbestimmungen finden Sie hier.
      </BaseLink>
      <BaseText>Ihr Team vom ista Express Service</BaseText>
    </BaseModalContent>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type {
  AlternativeContact,
  FormattedTimeslot
} from '~/terminierungsportal/types/appointmentTypes'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import BaseModalHeader from '~/base/components/modal/ModalHeader.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseModalContent from '~/base/components/modal/ModalContent.vue'
import BaseText from '~/base/components/text/Text.vue'
import BaseLink from '~/base/components/link/Link.vue'
import type { ContactInfo } from '~/base/types/contact/contact'

const appointmentStore = useAppointmentStore()

const alternativeContact = computed((): AlternativeContact => {
  return appointmentStore.alternativeContact
})

const contactInfo = computed((): ContactInfo => {
  return appointmentStore.contactInfo
})

const address = computed((): string => {
  return appointmentStore.formattedAddress
})

const timeslot = computed((): FormattedTimeslot => {
  return appointmentStore.formattedTimeslot
})

const workOrderId = computed((): string => {
  return appointmentStore.appointment.workOrderId
})

const childShortUrl = computed((): string => {
  return appointmentStore.appointment.childShortUrl
})
</script>
